import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { ACCESS_LOG_BASE, BackLink, DocumentBundleAccessKeysView } from '../components/views/documentBundleAccessView'

// Sentinel-admin only; the view's API calls re-check `isAdminUser`.
function DocumentBundleAccessKeys() {
    return (
        <div className="documentBundleAccessKeys">
            <Sidebar />
            <MainView>
                <BackLink to={ACCESS_LOG_BASE} text="Back to access log" />
                <ViewTitle text="Bundle Access Keys" />
                <DocumentBundleAccessKeysView />
            </MainView>
        </div>
    )
}

export default DocumentBundleAccessKeys
